import React, { useCallback, useEffect, useState } from 'react';

//primereact stuff
import { PrimeReactProvider } from 'primereact/api';

//heroui stuff
import { ToastProvider, HeroUIProvider } from '@heroui/react';

//css stuff
import './css/index.css';
import 'primereact/resources/themes/lara-light-blue/theme.css';
import 'react-pdf/dist/Page/TextLayer.css';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';

//router
import { BrowserRouter } from 'react-router-dom';
import RouterProvider from './router/RouterProvider';

//firebase stuff
import { auth, db } from './config/firebaseConfig';
import { doc, getDoc } from 'firebase/firestore';

//state stuff
import { StateProvider } from './state';
import AppReducer from './reducers/app.reducer';

//page loader
import PageLoader from './components/common/PageLoader';
import i18next from 'i18next';
import { enableSentry } from './services/sentry';
import { onAuthStateChanged } from 'firebase/auth';
import { useGlobal } from './state';

const getInitialState = {
    user: null,
    brand: null,
    finishedOnboarding: null,
    isSidebarOpen: true,
};

const AppContent = () => {
    const [currentAuthenticatedUser, setCurrentAuthenticatedUser] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [state, dispatch] = useGlobal();

    const getData = useCallback(
        async (user) => {
            setIsLoading(true);

            try {
                if (user) {
                    const docRef = doc(db, `users/${user.uid}`);
                    const docSnap = await getDoc(docRef);

                    if (docSnap.data()) {
                        const idToken = await auth.currentUser.getIdTokenResult();
                        const customClaims = idToken.claims;

                        dispatch({
                            type: 'USER',
                            user: { ...docSnap.data(), role: customClaims.role },
                        });

                        if (docSnap.data()?.personal?.language == 'eng') {
                            i18next.changeLanguage('eng');
                        } else {
                            i18next.changeLanguage('ro');
                        }

                        enableSentry(import.meta.env.MODE, '1.0.0', {
                            id: auth.currentUser.uid || '',
                            email: auth.currentUser?.email || '',
                        });
                    }
                }
            } catch (err) {
                console.log(err);
            }

            setCurrentAuthenticatedUser(user);
            setIsLoading(false);
        },
        [dispatch],
    );

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, getData);
        return () => unsubscribe();
    }, [getData]);

    return isLoading ? <PageLoader /> : <RouterProvider user={currentAuthenticatedUser} />;
};

export const App = () => {
    return (
        <HeroUIProvider>
            <ToastProvider placement="top-right" />

            <PrimeReactProvider value={{ ripple: true }}>
                <BrowserRouter
                    future={{
                        v7_relativeSplatPath: true,
                        v7_startTransition: true,
                    }}
                    basename="/"
                >
                    <StateProvider initialState={getInitialState} reducer={AppReducer}>
                        <AppContent />
                    </StateProvider>
                </BrowserRouter>
            </PrimeReactProvider>
        </HeroUIProvider>
    );
};

export default App;
